export default __webpack_public_path__ + "static/media/DIALO.ad5cd08c.png";